import { useCallback, useEffect, useState } from "react";
import { getDomainLinkageAllList } from "../services/domainLinkageService";

import DummyData from "../assets/dummy.json";

interface IFetchIssuesProps {
  searchFilterData: any;
  setIsLoading: (loading: boolean) => void;

  page: number;
  pSize: number;
}

const useFetchAllDomainLinkage = ({
  searchFilterData,
  setIsLoading,
  page,
  pSize,
}: IFetchIssuesProps) => {
  const [domainLinkageData, setDomainLinkageData] = useState<any[]>([]);

  const fetchDomainLinkageList = useCallback(async () => {
    if (Object.keys(searchFilterData).length > 0) {
      setIsLoading(true);
      try {
        // Transform searchFilterData to match API parameter names
        const {
          date,
          domain_linkage_ids,
          source_domain_id,
          target_domain_id,
          source_domain_key,
          target_domain_key,
          status_filter,
          ...otherFilters
        } = searchFilterData;

        // Build API payload with correct parameter names
        const apiPayload: any = {
          ...otherFilters,
        };

        // Map domain_linkage_ids to domain_linkage_filter_ids (comma-separated)
        if (
          domain_linkage_ids &&
          Array.isArray(domain_linkage_ids) &&
          domain_linkage_ids.length > 0
        ) {
          apiPayload.domain_linkage_filter_ids = domain_linkage_ids
            .map((item: any) => item.id || item)
            .join(",");
        }

        // Map source_domain_id to source_domain_id_filter (comma-separated)
        if (
          source_domain_id &&
          Array.isArray(source_domain_id) &&
          source_domain_id.length > 0
        ) {
          apiPayload.source_domain_id_filter = source_domain_id
            .map((item: any) => item.id || item)
            .join(",");
        }

        // Map target_domain_id to target_domain_id_filter (comma-separated)
        if (
          target_domain_id &&
          Array.isArray(target_domain_id) &&
          target_domain_id.length > 0
        ) {
          apiPayload.target_domain_id_filter = target_domain_id
            .map((item: any) => item.id || item)
            .join(",");
        }

        // Map source_domain_key to source_domain_key_filter
        if (source_domain_key && source_domain_key.trim()) {
          apiPayload.source_domain_key_filter = source_domain_key.trim();
        }

        // Map target_domain_key to target_domain_key_filter
        if (target_domain_key && target_domain_key.trim()) {
          apiPayload.target_domain_key_filter = target_domain_key.trim();
        }

        // Map status_filter to is_active (boolean)
        if (status_filter) {
          if (status_filter === "Active") {
            apiPayload.is_active = true;
          } else if (status_filter === "Inactive") {
            apiPayload.is_active = false;
          }
          // If "All", don't include is_active parameter
        }

        const result = await getDomainLinkageAllList({
          payload: apiPayload,
          page,
          pSize,
        });
        //const result: any = DummyData;
        setDomainLinkageData(result || []);
      } catch (error) {
        setDomainLinkageData([]);
      } finally {
        setIsLoading(false);
      }
    }
  }, [searchFilterData, setIsLoading, page, pSize]);

  useEffect(() => {
    fetchDomainLinkageList();
  }, [fetchDomainLinkageList]);

  return [domainLinkageData];
};

export default useFetchAllDomainLinkage;
